<!-- eslint-disable -->
<template>
  <CommonPages id="categories" :class="['categories']" :title="pageTitle"
    :metaDescription="pageDescription">
    <div class="categories-container">
      <!-- 顶部标题区域 -->
      <div class="categories-header" :class="[deviceType]">
        <div class="categories-title">Explore Baby Names by Category</div>
        <div class="categories-subtitle">Discover names organized by style, sound, meaning, and
          more.</div>
      </div>

      <!-- 分类卡片区域 -->
      <div class="categories-cards" :class="[deviceType]">
        <template v-for="(section, sectionIndex) in categories">
          <div class="category-card" :key="sectionIndex">
            <div class="card-header">
              <div class="card-icon">
                <div class="icon-bg"></div>
                <img :src="section.icon" :alt="section.title" class="icon-img" />
              </div>
              <div class="card-title">{{ section.title }}</div>
            </div>
            <div class="card-items">
              <router-link v-for="(item, itemIndex) in section.items" :key="itemIndex"
                :to="getCategoryPath(section.title, item.title)" tag="div" class="card-item">
                <div class="item-text">{{ item.title }}</div>
                <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="item-arrow" />
              </router-link>
            </div>
            <router-link :to="getCategoryPath(section.title)" tag="div" class="card-footer">
              <div class="view-all">View All</div>
              <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="footer-arrow" />
            </router-link>
          </div>
          <AdComponent v-if="deviceType === 'mobile' && sectionIndex === 0" :key="'ads-category-1'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_1"
            ref="ads-category-1" class="ad-width-100 " :ads="adsensConfig?.categories_1"
            :showDebug="showDebug" />
        </template>
      </div>

    </div>

    <AdComponent :key="'ads-category-2'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_2"
      ref="ads-category-2" class="ad-width-100 pc_padding m_padding"
      :ads="adsensConfig?.categories_2" :showDebug="showDebug" />

    <!-- 组合模块 -->
    <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
      <div class="section-header">
        <div class="section-dot"></div>
        <div class="section-title">Combinations</div>
      </div>
      <div class="combinations-container">
        <div class="combination-row" :class="[deviceType]">
          <div class="combination-card" v-for="(combo, index) in combinations" :key="index"
            @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
            @mouseleave="hoveredCombination = null"
            :class="{'hovered': hoveredCombination === index}">
            <div class="combination-text">
              {{ combo.title }}
            </div>
            <div class="see-more-button">
              <span>See More</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="arrow-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <AdComponent v-if="deviceType === 'mobile' " :key="'ads-category-3'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_3"
      ref="ads-category-3" class="ad-width-100 m_padding" :ads="adsensConfig?.categories_3"
      :showDebug="showDebug" />

    <section class="search-sec-row" :class="[deviceType]">
      <!-- 搜索过滤区域 -->
      <div class="section-header" :class="[deviceType]">
        <div class="section-dot"></div>
        <div class="section-title">Search by Filter</div>
      </div>

      <div class="names-filter" :class="[deviceType]">
        <SearchFilter />
      </div>
    </section>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'

import '@/css/categories.scss';
import '@/css/common.scss';

export default {
  name: 'Categories',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      hoveredCombination: null,
      combinations: [],
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'showDebug',
      'deviceType',
      'domainConfig',
      'gender',
      'style',
      'meaning'
    ]),
    pageTitle () {
      return 'Categories - Filter by Style, Gender, and More';
    },
    pageDescription () {
      const origin = this.domainConfig?.origin || '';
      return `View all filters and categories to help you find the perfect ${origin} name. Sort by gender, style, syllables, and more.`;
    },
    categories () {
      const result = [];
      if (this.gender && this.gender.length > 0) {
        result.push({
          title: 'Name by Gender',
          icon: require('@/assets/icons/gender.svg'),
          items: this.gender.slice(0, 3).map(i => ({ title: i }))
        });
      }
      if (this.style && this.style.length > 0) {
        result.push({
          title: 'Name by Style',
          icon: require('@/assets/icons/style.svg'),
          items: this.style.slice(0, 3).map(i => ({ title: i }))
        });
      }
      if (this.meaning && this.meaning.length > 0) {
        result.push({
          title: 'Name by Meaning',
          icon: require('@/assets/icons/meaning.svg'),
          items: this.meaning.slice(0, 3).map(i => ({ title: i }))
        });
      }
      return result;
    }
  },
  async mounted () {
    this.fetchCombinations();
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  },
  methods: {
    getCategoryPath (sectionTitle, itemTitle = null) {
      let categoryType = '';
      switch (sectionTitle) {
        case 'Name by Gender':
          categoryType = 'gender';
          break;
        case 'Name by Style':
          categoryType = 'style';
          break;
        case 'Name by Meaning':
          categoryType = 'meaning';
          break;
        default:
          categoryType = 'general';
      }

      if (itemTitle) {
        const formattedValue = itemTitle.toLowerCase();
        return `/categories/${categoryType}/${formattedValue}`;
      } else {
        return `/categories/${categoryType}`;
      }
    },
    async fetchCombinations () {
      const origin = this.domainConfig?.origin || '';
      try {
        const params = { origin };
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
        this.combinations = [];
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    }
  }
};
</script>

<style lang="scss" >
@import '~@/css/variables.scss';
.el-select-dropdown__list {
	padding: rem(3) 0;
}
.el-select-dropdown__item {
	padding: 0 rem(3) !important;
}
.el-select-dropdown__item.selected {
	color: #a31984;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background: rgba(163, 25, 132, 0.1);
}
.el-form {
	padding-bottom: 0;
}
.el-input__inner {
	border-radius: rem(20);
	border: rem(2) solid rgba(163, 25, 132, 0.1);
	background: #fff;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #a31984;
}
.el-input__inner:hover {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select:hover .el-input__inner {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select .el-input__inner:focus {
	border-color: #a31984;
}

.detect_deviece_mobile {
	.el-select-dropdown__item {
		font-size: rem(13);
		line-height: rem(34);
		height: rem(34);
	}
	.el-input__inner {
		height: rem(60);
		padding: rem(18) rem(44) rem(18) rem(24);
		border-radius: rem(20);
		border: rem(2) solid rgba(163, 25, 132, 0.1);
		background: #fff;
		color: #03133a;
		font-size: rem(18);
		font-style: normal;
		font-weight: 700;
		line-height: rem(20); /* 111.111% */
		text-transform: capitalize;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}
	.el-input__suffix {
		right: rem(24);
	}
	.el-select__caret {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.sort-select {
		.el-input__inner {
			border: none !important;
			border-radius: 0;
			color: #a31984;
			font-size: rem(16);
			font-style: normal;
			font-weight: 700;
			height: rem(16); /* 100% */
			line-height: rem(16); /* 100% */
			text-transform: capitalize;
		}
		.el-input__suffix {
			right: rem(8);
		}
		.el-select__caret {
			font-size: rem(16);
		}
	}
}
</style>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.categories {
	.categories-container {
		background: linear-gradient(180deg, rgba(163, 25, 132, 1) 0%, rgba(163, 25, 132, 0.6) 69.65%, rgba(163, 25, 132, 0) 100%);
		width: 100%;
		padding-bottom: rem(52);
	}

	// 顶部标题区域样式
	.categories-header {
		padding: rem(52) 0;
		display: flex;
		flex-direction: column;
		gap: rem(24);
		align-items: center;
		justify-content: center;
		position: relative;

		.categories-title {
			color: transparent;
			text-align: center;
			font-size: rem(52);
			line-height: rem(68);
			font-weight: 900;
			position: relative;
			-webkit-text-stroke: rem(1) #ffffff;
			background: linear-gradient(108.74deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.8) 30%, rgba(255, 255, 255, 1) 100%);
			-webkit-background-clip: text;
			background-clip: text;
			padding: 0 rem(180);
		}

		.categories-subtitle {
			color: #ffffff;
			text-align: center;
			font-size: rem(20);
			line-height: rem(28);
			font-weight: 400;
			position: relative;
			padding: 0 rem(180);
		}

		&.mobile {
			padding: rem(32) rem(16);

			.categories-title {
				font-size: rem(32);
				line-height: rem(40);
				padding: 0;
			}

			.categories-subtitle {
				font-size: rem(16);
				line-height: rem(24);
				padding: 0;
			}
		}
	}

	// 分类卡片区域样式
	.categories-cards {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		position: relative;
		gap: rem(24);

		.category-card {
			background: linear-gradient(139.77deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.9) 59.95%, rgba(255, 255, 255, 0.6) 100%);
			border-radius: rem(36);
			border: rem(1) solid rgba(255, 255, 255, 0.02);
			padding: rem(24);
			display: flex;
			flex-direction: column;
			gap: rem(20);
			align-items: flex-start;
			justify-content: flex-start;
			width: rem(344);
			position: relative;

			.card-header {
				display: flex;
				flex-direction: row;
				gap: rem(16);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.card-icon {
					width: rem(36);
					height: rem(36);
					position: relative;

					.icon-bg {
						background: #a31984;
						border-radius: rem(12);
						width: rem(36);
						height: rem(36);
						position: absolute;
						left: 0;
						top: 0;
						aspect-ratio: 1;
					}

					.icon-img {
						width: rem(20);
						height: rem(20);
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
						overflow: visible;
						aspect-ratio: 1;
					}
				}

				.card-title {
					color: #a31984;
					text-align: left;
					font-size: rem(20);
					line-height: rem(20);
					font-weight: 900;
					position: relative;
				}
			}

			.card-items {
				display: flex;
				flex-direction: column;
				gap: rem(8);
				align-items: flex-end;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.card-item {
					background: #ffffff;
					border-radius: rem(20);
					border: rem(2) solid rgba(163, 25, 132, 0.1);
					padding: rem(18) rem(24);
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					align-self: stretch;
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&:hover {
						border-color: rgba(163, 25, 132, 0.3);
					}

					.item-text {
						color: #03133a;
						text-align: left;
						font-size: rem(18);
						line-height: rem(20);
						font-weight: 700;
						position: relative;
					}

					.item-arrow {
						width: rem(6);
						height: rem(12);
						position: relative;
					}
				}
			}

			.card-footer {
				border-radius: rem(12);
				padding: rem(8) rem(24);
				display: flex;
				flex-direction: row;
				gap: rem(12);
				align-items: center;
				justify-content: flex-end;
				align-self: stretch;
				position: relative;
				cursor: pointer;

				.view-all {
					color: #a31984;
					text-align: center;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 700;
					position: relative;
				}

				.footer-arrow {
					width: rem(6);
					height: rem(12);
					position: relative;
				}
			}
		}

		&.mobile {
			padding: rem(16);
			flex-direction: column;
			gap: rem(16);
			margin-top: rem(-16);

			.category-card {
				width: 100%;
			}
		}
	}

	// 搜索过滤区域样式
	.search-sec-row {
		gap: rem(24);
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
	}
	.names-filter {
		padding: 0 rem(180);
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.filter-container {
			background: #f7f3f3;
			border-radius: rem(36);
			padding: rem(32);
			display: flex;
			flex-direction: column;
			gap: rem(48);
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;
			position: relative;

			.filter-rows {
				display: flex;
				flex-direction: column;
				gap: rem(24);
				align-items: flex-start;
				justify-content: flex-start;
				width: 100%;
				position: relative;

				.filter-row {
					display: flex;
					flex-direction: row;
					gap: rem(28);
					align-items: center;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.filter-item {
						display: flex;
						flex-direction: column;
						gap: rem(8);
						align-items: flex-start;
						justify-content: flex-start;
						flex: 1;
						position: relative;

						&.opacity-0 {
							opacity: 0;
						}

						.filter-label {
							padding: 0 rem(20);
							color: #03133a;
							text-align: left;
							font-size: rem(16);
							line-height: rem(16);
							font-weight: 400;
							position: relative;
						}

						:deep(.filter-select) {
							width: 100%;
							border-radius: rem(20);

							.el-input__wrapper {
								background: #ffffff;
								border-radius: rem(20);
								border: rem(2) solid rgba(163, 25, 132, 0.1);
								padding: rem(18) rem(24);
								box-shadow: none !important;
								height: rem(60);
								transition: all 0.3s ease;
								cursor: pointer;

								&:hover {
									border-color: rgba(163, 25, 132, 0.3);
								}

								&.is-focus {
									border-color: #a31984;
								}

								.el-input__inner {
									color: #03133a;
									font-size: rem(18);
									line-height: rem(20);
									font-weight: 700;
									height: 100%;
									max-width: calc(100% - rem(20));
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}

							&.active .el-input__wrapper {
								border-color: #a31984;
							}

							.el-select__caret {
								color: #03133a;
								font-size: rem(18);
							}
						}
					}
				}
			}

			.filter-actions {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.generate-button {
					background: #a31984;
					border-radius: rem(100);
					padding: rem(20) rem(32);
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(320);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						opacity: 0.8;
					}

					.generate-icon {
						width: rem(28);
						height: rem(28);
					}

					span {
						color: #ffffff;
						text-align: center;
						font-size: rem(22);
						line-height: rem(24);
						font-weight: 900;
						position: relative;
					}
				}

				.reset-button {
					border-radius: rem(100);
					border: rem(1) solid #a31984;
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(160);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						background: #a31984;

						span {
							color: #ffffff;
						}

						.reset-icon {
							filter: brightness(0) invert(1);
						}
					}

					.reset-icon {
						width: rem(20);
						height: rem(20);
					}

					span {
						color: #a31984;
						text-align: left;
						font-size: rem(20);
						line-height: rem(20);
						font-weight: 700;
						position: relative;
					}
				}
			}
		}

		&.mobile {
			padding: 0 rem(16);

			.filter-container {
				padding: rem(32);
				gap: rem(32);

				.filter-rows {
					gap: rem(16);
				}

				.filter-actions {
					flex-direction: column;
					gap: rem(16);

					.generate-button,
					.reset-button {
						width: 100%;
						padding: rem(20) 0;
					}
				}
			}
		}
	}
	.filter-item {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		flex: 1;
		position: relative;

		&.opacity-0 {
			opacity: 0;
		}

		.filter-label {
			padding: 0 rem(20);
			color: #03133a;
			text-align: left;
			font-size: rem(16);
			line-height: rem(16);
			font-weight: 400;
			position: relative;
		}

		:deep(.filter-select) {
			width: 100%;
			border-radius: rem(20);

			.el-input__wrapper {
				background: #ffffff;
				border-radius: rem(20);
				border: rem(2) solid rgba(163, 25, 132, 0.1);
				padding: rem(18) rem(24);
				box-shadow: none !important;
				height: rem(60);
				transition: all 0.3s ease;
				cursor: pointer;

				&:hover {
					border-color: rgba(163, 25, 132, 0.3);
				}

				&.is-focus {
					border-color: #a31984;
				}

				.el-input__inner {
					color: #03133a;
					font-size: rem(18);
					line-height: rem(20);
					font-weight: 700;
					height: 100%;
					max-width: calc(100% - rem(20));
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			&.active .el-input__wrapper {
				border-color: #a31984;
			}

			.el-select__caret {
				color: #03133a;
				font-size: rem(18);
			}
		}
	}
	.detect_deviece_mobile & {
		padding: rem(60) 0;

		.section-header {
			padding: 0 rem(16);
		}

		.names-filter {
			padding: 0 rem(16);

			.filter-container {
				padding: rem(32);
				gap: rem(32);

				.filter-rows {
					gap: rem(16);
				}

				.filter-actions {
					flex-direction: column;
					gap: rem(16);

					.generate-button,
					.reset-button {
						width: 100%;
						padding: rem(20) 0;
					}
				}
			}
		}

		.filter-item {
			width: 100%;
		}
		.el-select__caret {
			display: flex !important;
			align-items: center !important;
			justify-content: center !important;
		}
	}
	// 组合模块样式
	.combinations-section {
		padding: rem(32) 0;
		display: flex;
		flex-direction: column;
		gap: rem(32);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		margin-bottom: rem(32);

		.combinations-container {
			padding: 0 rem(180);
			display: flex;
			flex-direction: column;
			gap: rem(24);
			align-items: center;
			justify-content: space-between;
			align-self: stretch;
			position: relative;

			.combination-row {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;
				flex-wrap: wrap;
				gap: rem(24);
				width: 100%;
				&.mobile {
					.combination-card {
						flex-direction: column;
						gap: rem(24);
						align-items: flex-end;
					}
				}
			}

			.combination-card {
				background: #f7f3f3;
				border-radius: rem(36);
				padding: rem(28) rem(32);
				display: flex;
				flex-direction: row;
				gap: rem(84);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				// flex: 1;
				flex: 0 0 calc((100% - rem(24)) / 2); /* 使每个子元素占1/3的宽度 */
				// width: calc(50% - rem(12));
				position: relative;
				transition: all 0.3s ease;
				cursor: pointer;

				&.active {
					background: #ffffff;
					border: rem(1) solid #a31984;

					.combination-text {
						color: #a31984;
						font-weight: 700;
					}
				}

				&:hover {
					background: #ffffff;
					border: rem(1) solid #a31984;

					.combination-text {
						color: #a31984;
						font-weight: 700;
					}
				}

				.combination-text {
					color: #03133a;
					text-align: left;
					font-size: rem(18);
					line-height: rem(28);
					font-weight: 400;
					position: relative;
					flex: 1;
				}

				.see-more-button {
					border-radius: rem(12);
					border: rem(1) solid #a31984;
					padding: rem(8) rem(16);
					display: flex;
					flex-direction: row;
					gap: rem(8);
					align-items: center;
					justify-content: flex-start;
					position: relative;
					transition: all 0.3s ease;
					cursor: pointer;

					&.active {
						background: #a31984;

						span {
							color: #ffffff;
						}
					}

					span {
						color: #a31984;
						text-align: center;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 700;
						position: relative;
					}

					.arrow-icon {
						width: rem(6);
						height: rem(10);
					}
				}
			}
		}

		&.mobile {
			.section-header {
				padding: 0 rem(16);
			}

			.combinations-container {
				padding: 0 rem(16);

				.combination-row {
					flex-direction: column;
					gap: rem(16);
				}

				.combination-card {
					width: 100%;
				}
			}
		}
	}
	// 标题区域样式
	.section-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.section-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.section-title {
			color: #03133a;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}

		&.mobile {
			padding: 0 rem(16);
		}
	}
}
</style> 